import React, { useRef } from "react";
import { Bar, getElementAtEvent, getElementsAtEvent } from "react-chartjs-2";
import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Colors,
  LinearScale,
  Tooltip,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";
import { findSource } from "../scripts/utils";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";

type Props = {
  labelsArr: any;
  dataArr: any;
  profiles?: any;
};

const HorisontalChart: React.FC<Props> = ({
  labelsArr,
  dataArr,
  profiles,
}: Props) => {
  Chart.register(
    Colors,
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    ArcElement,
    ChartDataLabels
  );

  const labels = labelsArr.map((it: any) => findSource(it));
  const feedFilter = useSelector(getFeedFilter);
  const data: any = {
    labels: labels,
    datasets: [
      {
        label: "Кол-во постов",
        data: dataArr,
        sources: labelsArr,
        profiles: profiles,
        backgroundColor: "#B293FF",
        borderColor: "#B293FF",
        borderWidth: 0,
        borderRadius: 5,
        borderSkipped: false,
        padding: 6,
        datalabels: {
          align: "end",
          anchor: "start",
          font: {
            weight: "normal",
            size: 12,
          },
        },
      },
    ],
  };

  const chartRef: any = useRef();
  const navigate = useNavigate();

  const onClick = (event: any) => {
    console.log(
      "from:",
      feedFilter.from.slice(0, 10) + " 00:00:00",
      "to:",
      feedFilter.to.slice(0, 10) + " 23:59:59"
    );
    if (!profiles && getElementsAtEvent(chartRef.current, event).length > 0) {
      const indexNum = getElementsAtEvent(chartRef.current, event)[0].index;
      const source = data.datasets[0].sources[indexNum];
      navigate(
        `/thread?source=${source}&from=${
          feedFilter.from.slice(0, 10) + " 00:00:00"
        }&to=${feedFilter.to.slice(0, 10) + " 23:59:59"}`
      );
    } else {
      const indexNum = getElementsAtEvent(chartRef.current, event)[0].index;
      const profile = data.datasets[0].profiles[indexNum];
      console.log("DATA", data.datasets[0].profiles[indexNum]);
      const pr = '14314370468741339828'
      navigate(
        `/thread?profile_id=${profile}&from=${
          feedFilter.from.slice(0, 10) + " 00:00:00"
        }&to=${feedFilter.to.slice(0, 10) + " 23:59:59"}`
      );
    }
  };

  return (
    <div>
      <Bar
        ref={chartRef}
        data={data}
        onClick={onClick}
        options={{
          indexAxis: "y" as const,
          scales: {
            x: {
              display: false,
              clip: false,
              grid: { display: false, lineWidth: 0 },
              border: { display: false, width: 0 },
              offset: true,
            },
            y: {
              display: false,
              clip: false,
              grid: { display: false, lineWidth: 0 },
              border: { display: false, width: 0 },
            },
          },
          plugins: {
            tooltip: {
              enabled: false,
              position: "nearest",
            },
            datalabels: {
              align: "start",
              anchor: "end",
              color: function (context: any) {
                return "black";
              },
              font: function (context) {
                var w = context.chart.width;
                return {
                  size: 5,
                  weight: "normal",
                };
              },
              padding: 20,
              formatter: function (value: any, context: any) {
                return (
                  context.chart.data.labels[context.dataIndex] +
                  " - " +
                  context.chart.data.datasets[0].data[context.dataIndex]
                );
              },
            },
          },
        }}
        plugins={[
          {
            id: "drawBar",
            beforeDraw(chart) {
              const { config } = chart;
            },
          },
        ]}
      />
    </div>
  );
};

export default HorisontalChart;
